import { fromJson } from '@client/core/data/concerns/parses-from-json';
import { User } from '@client/features/user/models/user';
import { $t } from '@client/i18n/t';

/**
 * In the case that a user has been deleted and our response has null, we can parse to a common deleted user object.
 */
export const DELETED_USER = fromJson(User, { id: 0, name: $t('user.deletedUser') });
